import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import type { ShippingGatewayProvider } from '../ShippingGatewayProvider'

@InputType()
export class GetShippingFormDownloadArgs extends ActionArgs {
  @Field(() => String)
  labelId: string

  @Field(() => String)
  formDownloadValue?: string

  @Field(() => String)
  gatewayProvider: ShippingGatewayProvider
}

export interface IGetShippingFormDownload extends IAction<string, GetShippingFormDownloadArgs> {}
